module.exports = __webpack_public_path__ + "media/images/subject_img/PHILOSOPHY-0bf95ee2d132a23d46092adf9b664892.jpg";